import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

const entityKey = 'testing-actions';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const TestingActionsReducer = combineReducers({
    selection: selectionSlice.reducer,
});
